// extracted by css-extract-rspack-plugin
export default {"payment":"Payment_payment__SHQvh"};